import React, { useContext } from 'react'
import {
  Title,
  PeerComparisonReport,
  ReportSelector,
  InfoTooltipLink,
  ScholarshipSources,
} from 'components'
import { I18nContext } from 'i18n'
import { Container, Row, Col } from 'react-bootstrap'

const ReportsPage = ({ report }) => {
  const { translate } = useContext(I18nContext)
  const title = report === 'peer' ? 'peer_report_title' : 'criteria_report_title'

  return (
    <Container>
      <Row>
        <Col>
          <ReportSelector criteria={report} />
        </Col>
      </Row>
      <Row>
        <Col>
          <Title className="d-flex">
            {translate(title)}
            <InfoTooltipLink
              text={report === 'peer' ? translate('tooltipPeerComparisonReport') : translate('tooltipCriteriaComparison')}
              link={report === 'peer' ? translate('peerComparisonReportLink') : translate('criteriaComparisonLink')}
              style={{fontSize: 19, marginLeft: 15}}
              placement="right"
            />
          </Title>
          <PeerComparisonReport criteria={report} title={title} />
          <ScholarshipSources className="mt-3"/>
        </Col>
      </Row>
    </Container>
  )
}

export default ReportsPage
